export default function categoryNameToHumanReadableCategoryName(name: string) {
  if (name === 'HomeComfort') {
    return 'Home Comfort';
  }
  return name;
}